import {Box, Grid, Typography} from '@logistics-frontend/blocks'
import dayjs from 'dayjs'
import React, {useMemo} from 'react'

import {classes} from './Disclaimer.classes'
import {DEFAULT_PHOEINX_SURGE_LINK, DEFAULT_SURGE_LINK} from './Disclaimer.consts'
import {useStrictTranslator} from './Disclaimer.hooks'
import {DisclaimerPlaceholder, DisclaimerProps} from './Disclaimer.types'
import {localizedVariants} from './Disclaimer.utils'

const isPhoenix = window.location.pathname.startsWith('/account2')
const defaultSurgeLink = isPhoenix ? DEFAULT_PHOEINX_SURGE_LINK : DEFAULT_SURGE_LINK

const Disclaimer: React.FC<DisclaimerProps> = ({
  city,
  country,
  zone,
  tariff,
  disclaimerKey,
  surgeLink = defaultSurgeLink,
}) => {
  const t = useStrictTranslator()

  const surge = useMemo(() => {
    const hasSurge = !tariff.disable_surge

    return hasSurge ? t('cargo.tariffs.disclaimer.surge', {link: surgeLink}) : ''
  }, [t, tariff, surgeLink])

  const __html = useMemo(() => {
    if (!!disclaimerKey) {
      return t(disclaimerKey, {
        city,
        time: dayjs().format('DD.MM.YY'),
        surge,
      })
    }

    return localizedVariants<DisclaimerPlaceholder>(
      t,
      country,
      zone,
      tariff.category_name,
    )('cargo.tariffs.disclaimer', {city, time: dayjs().format('DD.MM.YY'), surge})
  }, [city, country, disclaimerKey, t, tariff, surge, zone])

  return (
    <Grid spacing={2} container>
      <Grid item xs>
        <article className={classes.container}>
          <Box className={classes.box} data-e2e="disclaimer-tariff">
            <Typography color="minor" dangerouslySetInnerHTML={{__html}} flexWrap="wrap" variant="caption2" />
          </Box>
        </article>
      </Grid>
    </Grid>
  )
}

export default Disclaimer
